import { httpRequest } from './Axios';

/* ── Auth (public — no x-api-key needed) ── */
export const PW_Login_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/auth/login', data }, false);
};

/* ── Master Data ── */
export const PW_Products_API = async () => {
  return await httpRequest({ method: 'GET', url: '/products' });
};

export const PW_Stores_API = async () => {
  return await httpRequest({ method: 'GET', url: '/stores' });
};

export const PW_Users_API = async () => {
  return await httpRequest({ method: 'GET', url: '/users' });
};

export const PW_Calendar_API = async (params) => {
  return await httpRequest({ method: 'GET', url: '/calendar', params });
};

/* ── Coupon generation (server-side; shared by Web + Mobile) ── */
// `pick6: true` tells the API this build can run Pick 6 rounds; without it the
// API refuses them (old mobile builds). Other products ignore it.
export const PW_Coupon_Generate_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/coupon/generate', data: { ...data, pick6: true } });
};

// Authoritative sale — server decides the outcome + records the ticket atomically.
export const PW_Coupon_Sell_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/coupon/sell', data: { ...data, pick6: true } }, false);
};

/* ── Transactions ── */
export const PW_Transactions_List_API = async (params) => {
  return await httpRequest({ method: 'GET', url: '/transactions', params });
};

// Per store+product sale counts for the Coupon page. No full-screen loader: it
// refreshes in the background after every sale.
export const PW_Transaction_Counts_API = async (params) => {
  return await httpRequest({ method: 'GET', url: '/transactions/counts', params }, false);
};

export const PW_Transaction_Save_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/transactions', data }, false);
};

/* ── Save endpoints (fire-and-forget from UI) ── */
export const PW_User_Save_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/users', data }, false);
};
export const PW_User_Delete_API = async (id) => {
  return await httpRequest({ method: 'DELETE', url: `/users/${id}` }, false);
};
export const PW_UserStoreRight_Save_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/users/rights', data }, false);
};
export const PW_Store_Save_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/stores', data }, false);
};
export const PW_Store_Delete_API = async (id) => {
  return await httpRequest({ method: 'DELETE', url: `/stores/${id}` }, false);
};
export const PW_Product_Save_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/products', data }, false);
};
export const PW_ProductTypeLink_Toggle_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/products/link-toggle', data }, false);
};
export const PW_WinnerConfig_Save_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/products/winner-config', data }, false);
};
export const PW_WinningOptions_Save_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/products/winning-options', data }, false);
};
export const PW_ProductType_Save_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/products/types', data }, false);
};
export const PW_Calendar_Save_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/calendar', data }, false);
};
export const PW_Calendar_Delete_API = async (id) => {
  return await httpRequest({ method: 'DELETE', url: `/calendar/${id}` }, false);
};

/* ── Devices ── */
export const PW_Devices_List_API = async (status) => {
  const params = status ? { status } : undefined;
  return await httpRequest({ method: 'GET', url: '/devices', params });
};
export const PW_Device_Decide_API = async (id, data) => {
  return await httpRequest({ method: 'POST', url: `/devices/${id}/decide`, data }, false);
};
export const PW_Device_Relink_API = async (id, data) => {
  return await httpRequest({ method: 'POST', url: `/devices/${id}/relink`, data }, false);
};
export const PW_Device_Revoke_API = async (id, data) => {
  return await httpRequest({ method: 'POST', url: `/devices/${id}/revoke`, data }, false);
};
export const PW_Device_Delete_API = async (id) => {
  return await httpRequest({ method: 'DELETE', url: `/devices/${id}` }, false);
};
export const PW_Device_Rename_API = async (id, data) => {
  return await httpRequest({ method: 'PUT', url: `/devices/${id}/name`, data }, false);
};

/* ── Bonus Prize Schedules ── */
export const PW_BonusPrize_API = async () => {
  return await httpRequest({ method: 'GET', url: '/bonus-prizes' });
};
export const PW_BonusPrize_Save_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/bonus-prizes', data }, false);
};
export const PW_BonusPrize_Delete_API = async (id) => {
  return await httpRequest({ method: 'DELETE', url: `/bonus-prizes/${id}` }, false);
};
